// import ServicesPage from "./views/ServicesPage.vue";

const routes = [
  // {
  //   path: '/',
  //   redirect: 'services'
  // },
  // {
  //   path: '/services',
  //   name: 'services',
  //   component: ServicesPage,
  //   meta: {
  //     title: 'Services',
  //     requiresAuth: true
  //   }
  // }
];

export default routes;
